import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { 
  Smartphone, Laptop, Shirt, Home, Heart, Baby, 
  BookOpen, Dumbbell, Car, Gamepad, Pizza, Briefcase 
} from "lucide-react";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const Categories = () => {
  // Categories that match the Products page filter options
  const categories = [
    { 
      name: "Electronics", 
      slug: "electronics",
      icon: <Smartphone className="h-8 w-8" />, 
      color: "bg-blue-500/10 text-blue-600",
      description: "Phones, laptops, accessories"
    },
    { 
      name: "Fashion & Clothing", 
      slug: "fashion",
      icon: <Shirt className="h-8 w-8" />, 
      color: "bg-purple-500/10 text-purple-600",
      description: "Clothing, shoes, bags"
    },
    { 
      name: "Home & Garden", 
      slug: "home",
      icon: <Home className="h-8 w-8" />, 
      color: "bg-green-500/10 text-green-600",
      description: "Furniture, decor, appliances"
    },
    { 
      name: "Beauty & Health", 
      slug: "beauty",
      icon: <Heart className="h-8 w-8" />, 
      color: "bg-pink-500/10 text-pink-600",
      description: "Skincare, makeup, wellness"
    },
    { 
      name: "Toys & Games", 
      slug: "toys",
      icon: <Baby className="h-8 w-8" />, 
      color: "bg-yellow-500/10 text-yellow-600",
      description: "Toys, games, kids items"
    },
    { 
      name: "Books & Media", 
      slug: "books",
      icon: <BookOpen className="h-8 w-8" />, 
      color: "bg-indigo-500/10 text-indigo-600",
      description: "Books, movies, music"
    },
    { 
      name: "Sports & Outdoors", 
      slug: "sports",
      icon: <Dumbbell className="h-8 w-8" />, 
      color: "bg-orange-500/10 text-orange-600",
      description: "Equipment, apparel, outdoors"
    },
    { 
      name: "Automotive", 
      slug: "automotive",
      icon: <Car className="h-8 w-8" />, 
      color: "bg-gray-500/10 text-gray-600",
      description: "Parts, accessories, tools"
    },
    { 
      name: "Food & Beverages", 
      slug: "food",
      icon: <Pizza className="h-8 w-8" />, 
      color: "bg-emerald-500/10 text-emerald-600",
      description: "Fresh food, snacks, beverages"
    },
    { 
      name: "Office Supplies", 
      slug: "office",
      icon: <Briefcase className="h-8 w-8" />, 
      color: "bg-slate-500/10 text-slate-600",
      description: "Office supplies, equipment"
    },
    { 
      name: "Jewelry & Accessories", 
      slug: "jewelry",
      icon: <Gamepad className="h-8 w-8" />, 
      color: "bg-red-500/10 text-red-600",
      description: "Jewelry, watches, accessories"
    },
    { 
      name: "Pet Supplies", 
      slug: "pet",
      icon: <Laptop className="h-8 w-8" />, 
      color: "bg-cyan-500/10 text-cyan-600",
      description: "Pet food, toys, accessories"
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <Breadcrumbs />
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Shop by Category</h1>
        <p className="text-muted-foreground">Browse products from our wide range of categories</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.map((category, index) => (
          <Link to={`/products?category=${category.slug}`} key={index}>
            <Card className="p-6 hover:shadow-lg transition-all hover:scale-105 cursor-pointer h-full">
              <div className={`rounded-lg p-3 inline-flex mb-3 ${category.color}`}>
                {category.icon}
              </div>
              <h3 className="font-semibold mb-1">{category.name}</h3>
              <p className="text-sm text-muted-foreground mb-2">{category.description}</p>
            </Card>
          </Link>
        ))}
      </div>

      <Card className="mt-12 p-8 bg-gradient-to-r from-primary/10 to-primary/5">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-3">Can't find what you're looking for?</h2>
          <p className="text-muted-foreground mb-6">
            Browse all products or contact us for assistance
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/products">
              <Button className="bg-primary hover:bg-primary/90">Browse All Products</Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline">Contact Support</Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Categories;